const LOGOUT_MESSAGE = 'logout';

// Delay so the emitting tab's /oauth2/sign_out has cleared the session cookie before the other tabs reload
const RELOAD_DELAY_MS = 1500;

const OAUTH_AUTH_URL = '/oauth2/auth';

const authChannel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel('auth') : null;

const reloadPage = () => window.location.reload();

/**
 * Calls onSessionEnded (reloads this tab by default, so forwardAuth redirects it to sign-in) when another tab logs out:
 * - right away for a tab of the same app,
 * - when this tab is shown again for a tab of another app: /oauth2/sign_out clears the cookies of every app,
 *   so /oauth2/auth answers 401.
 */
export function listenToLogoutFromOtherTabs(onSessionEnded: () => void = reloadPage): void {
  if (authChannel) {
    authChannel.onmessage = (event: MessageEvent) => {
      if (event.data === LOGOUT_MESSAGE) {
        setTimeout(onSessionEnded, RELOAD_DELAY_MS);
      }
    };
  }

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkSessionEnded(onSessionEnded);
    }
  });
}

/**
 * Tells the other tabs of the same app that this tab is logging out.
 */
export function notifyLogoutToOtherTabs(): void {
  authChannel?.postMessage(LOGOUT_MESSAGE);
}

// Only on 401: 403 means a session without access to this app, reloading would loop on the error page
function checkSessionEnded(onSessionEnded: () => void): void {
  fetch(OAUTH_AUTH_URL, { credentials: 'same-origin', cache: 'no-store' })
    .then((response) => {
      if (response.status === 401) {
        onSessionEnded();
      }
    })
    .catch(() => undefined);
}
